import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import NumberInput from '../../../../../../../../../../../../../../components/forms/number-input/NumberInput';
import { EMISSION_MAX_FRACTION_DIGIT } from '../../../../../../../../../../../../../../shared/constants/products.constant';
import WasteTreatmentDropDown from '../../../injection-molding-form/components/waste-treatment-dropdown/WasteTreatmentDropdown';

interface InputMaterialWasteManagementFormProps {
  processIndex: number;
}

const InputMaterialWasteManagementForm = ({
  processIndex,
}: InputMaterialWasteManagementFormProps) => {
  const {
    control,
    formState: { submitCount },
    trigger,
  } = useFormContext();

  const { t } = useTranslation();

  const wastePerPiece = useWatch({
    name: `processes[${processIndex}].waste_management.waste_per_piece`,
    control,
  });

  useEffect(() => {
    if (submitCount > 0) {
      trigger([`processes[${processIndex}].waste_management.waste_treatment`]);
    }
  }, [wastePerPiece]);

  return (
    <div className='grid'>
      <div className='col-6'>
        <NumberInput
          name={`processes[${processIndex}].waste_management.amount_per_piece`}
          control={control}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.placeholders.amountPerPiece',
          )}
          minFractionDigits={0}
          maxFractionDigits={EMISSION_MAX_FRACTION_DIGIT}
          suffix=' kg'
        />
      </div>
      <div className='col-6'>
        <NumberInput
          name={`processes[${processIndex}].waste_management.waste_per_piece`}
          control={control}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.placeholders.wastePerPiece',
          )}
          minFractionDigits={0}
          maxFractionDigits={EMISSION_MAX_FRACTION_DIGIT}
          suffix=' kg'
        />
      </div>
      <div className='col-12'>
        <WasteTreatmentDropDown
          name={`processes[${processIndex}].waste_management.waste_treatment`}
          label={t(
            'footprintDetailsPage.sections.calculatePcfSection.individualProcessSection.inputs.placeholders.wasteTreatment',
          )}
          processIndex={processIndex}
        />
      </div>
    </div>
  );
};

export default InputMaterialWasteManagementForm;
